module.exports = __webpack_public_path__ + "static/media/upcommerce_logo.4e1922ac.svg";